// extracted by mini-css-extract-plugin
export default {"ButtonLight":"ButtonLight_ButtonLight__YSF2d"};